import { render } from "./index.vue?vue&type=template&id=126a03a0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=126a03a0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-126a03a0"

export default script